import React from 'react';
import i18next from 'i18next';

function Diagnosys() {
    return (
        <>
            {i18next.language === 'ar' ? (
                <>
                    <h3 id='title'>تشخيص اضطراب طيف التوحد</h3>
                    <p>
                        لا يوجد اختبار طبي واضح لتشخيص الاضطراب، فلا يمكن لتحليل
                        الدم أو المسح الإشعاعي للدماغ أن يكون دليل دامغ لتشخيص
                        اضطراب طيف التوحد. على الرغم من أن الباحثين يحاولون
                        بنشاط مكثف لتطوير مثل هذه الاختبارات و مقاييس التشخيص.
                        في الوقت الحالي، يعتمد الأطباء/ المختصون الإكلينيكيين في
                        تشخيص اضطراب طيف التوحد على ملاحظة سلوك الطفل لتحديد
                        وجود الأعراض الأساسية للتوحد وهي :صعوبات في التواصل،
                        وعدم التفاعل اجتماعياً والسلوكيات التكرارية والمقيدة.
                    </p>
                    <h4 id='title'>
                        اختبار الكشف عن خطر الاصابة باضطراب طيف التوحد
                    </h4>
                    <h5 id='title'>
                        (M-CHAT) اختبار قائمة استبيان التوحد عند الأطفال
                    </h5>
                    <p>
                        (من عمر ١٦ إلى ٣٠ شهراً) هو اختبار للكشف وتحديد الأطفال
                        الذين هم في خطر الإصابة باضطراب طيف التوحد، الطريقة هي
                        أثناء مواعيد الفحص الطبي الدوري للطفل في عمر ١٨ و ٢٤
                        شهرًا يتم إعطاء الوالدين اختبار قائمة (استبيان التوحد
                        عند الأطفال) ويطلب منهم الإجابة على ٢٠ سؤال &quot;بنعم
                        أو لا&quot; حول مهارات الطفل الاجتماعية والحركية
                        واللغوية. تبعاً لنتيجة الاختبار، يقوم الأطباء/ المختصون
                        الإكلينيكيين باستخدام الأدوات التشخيصية التي تحدد ما إذا
                        كان الطفل مصاب باضطراب طيف التوحد أم لا.
                    </p>
                    <h4 id='title'>تشخيص اضطراب طيف التوحد</h4>
                    <p id='list'>
                        يستخدم الأطباء/ المختصون الإكلينيكيين نوعين من
                        الاختبارات السلوكية الموثوقة لتشخيص اضطراب طيف التوحد:
                    </p>
                    <ul>
                        <li>
                            <b>(ADOS) جدول الملاحظة التشخيصية للتوحد:</b> حيث أن
                            الأطباء/ المختصون الإكلينيكيين يلاحظون سلوك الأطفال
                            وكيفية اندماجهم وتفاعلهم في مواقف اجتماعية مختلفة
                            لمدة تصل إلى ساعة.
                        </li>
                        <li>
                            <b>(ADI-R) المقابلة التشخيصية للتوحد:</b> حيث تتم من
                            خلال المقابلة الوالدية.
                        </li>
                    </ul>
                </>
            ) : (
                <>
                    <h3 id='autism-diagnosis'>Autism Diagnosis</h3>
                    <p>
                        Autism can not be diagnosed by a single gene, blood or
                        brain profile. Clinicians diagnose autism using
                        behavioral tests for the core features of the condition:
                        communication difficulties, social challenges and
                        restricted or repetitive behaviors.{' '}
                    </p>
                    <h4 id='the-screening-test-for-flag-people-at-risk-for-the-condition-'>
                        The screening test for flag people at risk for the
                        condition:
                    </h4>
                    <h5 id='the-modified-checklist-for-autism-in-toddlers-m-chat-'>
                        The Modified Checklist for Autism in Toddlers (M-CHAT)
                    </h5>
                    <p>
                        The Modified Checklist for Autism in Toddlers (M-CHAT)
                        for (16- 30 months). Parents answer 20 ‘yes-no’
                        questions about their child’s social, motor and language
                        skills at the child’s 18- and 24-month checkups. Then to
                        diagnose the children these screens flag, clinicians
                        typically use a pair of standardized behavioral tests:{' '}
                    </p>
                    <ul>
                        <li>
                            <strong>
                                The Autism Diagnostic Observation Schedule
                                (ADOS:
                            </strong>{' '}
                            Clinicians observe children’s behavior and how they
                            engage in social situations for up to an hour
                        </li>
                        <li>
                            <strong>
                                The Autism Diagnostic Interview-Revised (ADI-R):
                            </strong>{' '}
                            using parent interview
                        </li>
                    </ul>
                </>
            )}
        </>
    );
}

export default Diagnosys;
